export const MEETING_FRAGMENT = `
  fragment MeetingFields on Meeting {
    id
    tenant_id
    group_id
    month
    current_date
    current_date_2
    type
    rg1_mode
    rg2_mode
    ret_mode
    comments
    draft
    done
    operational_status
    current_host_id
    guests
    meetings
    has_presenter
    is_hired_presenter
    current_presenter_id
    selected_topic_id
    topic {
      id
      title
    }
    current_presentation_id
    extra_presenter
    extra_presenter_email
    extra_presentation
    pay_mode
    pay
    extra_pay
    expenses
    hash
    only_presentation
    its
    uts
    p3_average
    p4_average
    p5_average
    evaluation_count
    not_answered_count
    from_presentation {
      id
      exhibitor_comments
    }
    group {
      id
      name
    }
    current_host {
      id
      firstname
      lastname
    }
    current_presenter {
      id
      type
      pay
      pay_virtual
      pay_virtual_short
      contact {
        id
        firstname
        lastname
        email
      }
    }
    meeting_groups {
      id
      group_id
      approval_status
      attendance_loaded
      group {
        id
        name
      }
    }
    meeting_member {
      id
      member_id
      group_id
      group {
        id
        name
      }
      group_done
      group_done_2
      meeting_121_done
      critical
      critical_topic
      answered
      hash
      question_1
      question_2
      question_3
      question_4
      question_5
      uts
      group_comments
      presenter_comments
      exhibitor_absent
      absence_comment
      answer_date
      member {
        id
        contact {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const GET_MEETING = `
  query GetMeeting($tenant_id: Int!, $id: Int!) {
    meeting(tenant_id: $tenant_id, id: $id) {
      __typename

      ... on Meeting {
        ...MeetingFields
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
  ${MEETING_FRAGMENT}
`;

export const GET_MEETINGS = `
  query GetMeetings(
    $tenant_id: Int!
    $filter: MeetingFilterInput
    $order: MeetingOrderInput
    $page: Int
    $perPage: Int
  ) {
    meetings(
      tenant_id: $tenant_id
      filter: $filter
      order: $order
      page: $page
      perPage: $perPage
    ) {
      __typename

      ... on Meeting {
        ...MeetingFields
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
  ${MEETING_FRAGMENT}
`;

export const GET_MEETINGS_COUNT = `
  query GetMeetingsCount($tenant_id: Int!, $filter: MeetingFilterInput) {
    meetingsCount(tenant_id: $tenant_id, filter: $filter) {
      __typename

      ... on Count {
        count
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_GROUPS_FOR_MEETINGS = `
  query GetGroupsForMeetings($tenant_id: Int!, $skip: Int, $take: Int, $filter: GroupFilterInput) {
    groups(tenant_id: $tenant_id, skip: $skip, take: $take, filter: $filter, orderBy: { field: name, direction: asc }) {
      __typename

      ... on Group {
        id
        name
        monthly_date
        include
        program_variant_id
        program {
          category {
            include
            pro_bono
          }
          province {
            id
            name
            interior
          }
          pricings {
            id
            expenses
            is_active
            program_variant_id
            vistage_group_id
          }
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_EXHIBITORS_FOR_MEETINGS = `
  query GetExhibitorsForMeetings($tenant_id: Int!, $skip: Int, $take: Int, $filter: ExhibitorFilterInput, $searchText: String) {
    exhibitors(tenant_id: $tenant_id, skip: $skip, take: $take, filter: $filter, searchText: $searchText, orderBy: { field: id, direction: asc }) {
      __typename

      ... on Exhibitor {
        id
        pay
        pay_virtual
        pay_virtual_short
        roaming
        roaming_provinces
        contact {
          id
          firstname
          lastname
          province
          email
        }
        type
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_CONTACTS_FOR_MEETINGS = `
  query GetContactsForMeetings($tenant_id: Int!, $filter: ContactFilterInput) {
    contacts(tenant_id: $tenant_id, filter: $filter, order: { field: lastname, direction: asc }) {
      __typename

      ... on Contact {
        id
        firstname
        lastname
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_ACTIVE_MEMBERS_BY_GROUP = `
  query GetActiveMembersByGroup($tenant_id: Int!, $group_id: Int!) {
    getActiveMembersByGroup(tenant_id: $tenant_id, group_id: $group_id) {
      __typename

      ... on ActiveMember {
        member_id
        contact {
          id
          firstname
          lastname
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_MEETING_EVALUATION_RESULTS = `
  query GetMeetingEvaluationResults($meetingId: Int!) {
    getMeetingEvaluationResults(meetingId: $meetingId) {
      __typename

      ... on MeetingEvaluationResults {
        meetingId
        hasPresenter
        p1Average
        p2Average
        p3Average
        p4Average
        p5RecommendPercent
        totalMembers
        attendedCount
        attendancePercent
        criticalCount
        evaluationCount
        notAnsweredCount
        memberResults {
          memberId
          meetingMemberId
          memberName
          answered
          attended
          exhibitorAbsent
          hash
          answerDate
          question1
          question2
          question3
          question4
          question5
          groupComments
          presenterComments
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_EVALUATION_BY_HASH = `
  query GetEvaluationByHash($hash: String!) {
    getEvaluationByHash(hash: $hash) {
      __typename

      ... on EvaluationData {
        meetingId
        meetingMemberId
        groupName
        meetingDate
        memberName
        hasPresenter
        presenterName
        presenterTopic
        alreadyAnswered
        attended
        answerDate
        chairName
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const GET_MEETING_EVALUATION_BY_HASH = `
  query GetMeetingEvaluationByHash($hash: String!) {
    getMeetingEvaluationByHash(hash: $hash) {
      __typename

      ... on MeetingEvaluationData {
        meetingId
        groupName
        meetingDate
        hasPresenter
        presenterName
        presenterTopic
        chairName
        pendingMembers {
          meetingMemberId
          memberId
          memberName
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
